import { useMemo } from "react";
import { styled } from "styled-components";
import { Button, Modal } from "antd";
import { useTranslation } from "react-i18next";
import InlineSvg from "react-inlinesvg";

import { imgList } from "@constants/imgs";
import commonStore from "@zustand/common";

const ModalFailed = () => {
  const { t } = useTranslation();
  const { openModalFailed, setOpenModalFailed } = commonStore();

  const { open, onClose, title, destination } = useMemo(
    () => openModalFailed,
    [openModalFailed]
  );

  const handleCloseModal = () => {
    onClose?.();
    setOpenModalFailed({ open: false });
  };

  return (
    <Contents id="modal-failed">
      <Modal
        title={""}
        width={400}
        centered
        open={open}
        closable={false}
        getContainer={() =>
          document.getElementById("modal-failed") as HTMLElement
        }
        footer={false}
      >
        <InlineSvg src={imgList.failed} />
        <br />
        <div className="modal-failed__title">{t(title ?? "Common:error")}</div>
        <div className="modal-failed__description">
          {t(destination ?? "Common:error_detail")}
        </div>
        <br />
        <Button type="primary" onClick={handleCloseModal}>
          {t("Common:back_to_home")}
        </Button>
      </Modal>
    </Contents>
  );
};

export default ModalFailed;

const Contents = styled.div`
  .ant-modal-body {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    flex-direction: column;
  }
  .ant-modal-content {
    padding: 50px;
  }
  .modal-failed {
    &__title {
      font-size: 30px;
      font-style: normal;
      font-weight: 500;
      line-height: 32px;
      margin: 0 0 10px;
    }
    &__description {
      color: #667085;
      text-align: center;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px;
    }
  }
`;
